export const MOCK_ZONES = {
  last_updated: '2026-04-19',
  source_reference: 'JWC Listed Areas (Joint War Committee) — approximate boundaries',
  zones: [
    {
      id: 'red-sea-gulf-aden',
      name: 'Red Sea & Gulf of Aden',
      risk_level: 'high',
      description: 'Active Houthi missile and drone attacks on commercial shipping. All vessel types targeted.',
      polygon: [
        [29.9,32.5],[27,34.5],[22,37.5],[17,40.5],[14,42.5],
        [12.5,43.2],[11.0,43.5],[11.0,51.5],[14.5,51.5],
        [14.5,45.0],[12.5,44.0],[15,42.5],[20,39.5],
        [25,37.0],[28,35.0],[29.9,32.5],
      ],
      advisory_notes: 'All vessels strongly advised to register with UKMTO before transit. Consider alternative routing via Cape of Good Hope.',
    },
    {
      id: 'yemen-coast',
      name: 'Yemen Coastal Waters',
      risk_level: 'high',
      description: 'Highest concentration of Houthi drone and missile launch sites.',
      polygon: [[11.8,42.0],[11.8,53.5],[16.5,53.5],[16.5,42.0]],
      advisory_notes: 'Remain outside 12nm coastal exclusion zone where possible.',
    },
    {
      id: 'black-sea',
      name: 'Black Sea',
      risk_level: 'high',
      description: 'Active conflict zone — Russia/Ukraine war. Mine risk, missile strikes, and military activity.',
      polygon: [
        [41.0,28.0],[41.0,33.0],[43.0,35.5],[45.0,37.0],
        [47.0,39.5],[47.0,41.5],[45.5,41.5],[43.5,38.5],
        [42.5,36.0],[41.5,33.5],[41.0,29.0],
      ],
      advisory_notes: 'War risk insurance required. Consult flag state before entering.',
    },
    {
      id: 'sea-of-azov',
      name: 'Sea of Azov',
      risk_level: 'high',
      description: 'Effectively closed to commercial traffic.',
      polygon: [[45.2,34.0],[45.2,39.5],[47.5,39.5],[47.5,34.0]],
      advisory_notes: 'Do not enter without explicit government clearance.',
    },
    {
      id: 'persian-gulf',
      name: 'Persian Gulf',
      risk_level: 'elevated',
      description: 'IRGCN vessel interceptions, tanker seizures, and harassment.',
      polygon: [
        [22.0,48.5],[22.5,51.0],[23.5,53.5],[24.5,55.0],
        [26.5,56.5],[28.0,56.5],[30.0,50.5],[29.5,49.0],[27.5,48.5],
      ],
      advisory_notes: 'Maintain strict radio watch on VHF Ch 16.',
    },
    {
      id: 'iran-waters',
      name: 'Iran Territorial Waters',
      risk_level: 'elevated',
      description: 'Vessel detentions; high risk for US/UK/Israel-linked vessels.',
      polygon: [
        [25.0,50.5],[25.5,52.0],[26.5,54.5],[27.5,56.5],
        [27.5,58.0],[25.5,58.5],[24.5,57.0],[24.5,54.0],[25.0,51.5],
      ],
      advisory_notes: 'US-linked vessels face heightened seizure risk.',
    },
    {
      id: 'gulf-of-oman',
      name: 'Gulf of Oman',
      risk_level: 'elevated',
      description: 'Suspicious approaches; IRGCN interceptions near Strait of Hormuz.',
      polygon: [[22.0,55.5],[22.0,60.5],[24.5,61.5],[26.5,60.0],[26.5,56.5],[24.0,55.5]],
      advisory_notes: 'Keep strict bridge watch when transiting Strait of Hormuz approach lanes.',
    },
    {
      id: 'somali-coast-hra',
      name: 'Somali Coast HRA',
      risk_level: 'elevated',
      description: 'Resurgent piracy. Skiff attacks and boarding attempts reported.',
      polygon: [
        [-2.0,40.0],[-2.0,60.0],[5.0,62.0],[10.0,60.0],
        [15.0,53.0],[12.5,45.0],[10.0,41.0],[5.0,40.0],
      ],
      advisory_notes: 'BMP5 must be implemented. Armed security recommended east of 60°E.',
    },
    {
      id: 'libya-coast',
      name: 'Libyan Coastal Waters',
      risk_level: 'elevated',
      description: 'Armed militia vessels; contested maritime authority.',
      polygon: [[30.0,10.0],[30.0,25.5],[33.5,25.5],[33.5,10.0]],
      advisory_notes: 'Avoid approaches closer than 12nm to Libyan coast.',
    },
    {
      id: 'israel-waters',
      name: 'Israeli Territorial Waters',
      risk_level: 'elevated',
      description: 'Rocket, drone, and missile risk associated with regional conflict.',
      polygon: [[29.3,34.0],[29.3,35.5],[33.5,35.5],[33.5,34.0]],
      advisory_notes: 'Consult war risk underwriter before calling at Israeli ports.',
    },
    {
      id: 'lebanon-waters',
      name: 'Lebanese Coastal Waters',
      risk_level: 'elevated',
      description: 'Conflict spillover risk; Israeli military operations in southern Lebanon.',
      polygon: [[33.0,35.0],[33.0,36.5],[34.7,36.5],[34.7,35.0]],
      advisory_notes: 'War risk premium applies. Confirm coverage before calling.',
    },
    {
      id: 'west-africa-gog',
      name: 'Gulf of Guinea',
      risk_level: 'elevated',
      description: 'Piracy and armed robbery. Crew kidnapping for ransom offshore Nigeria.',
      polygon: [[-5.0,-5.0],[-5.0,10.0],[0.0,10.0],[5.0,8.5],[10.0,7.5],[10.0,-5.0]],
      advisory_notes: 'Register voyages with MTISC-GOG. Armed security recommended offshore.',
    },
  ],
};

export const MOCK_INCIDENTS = {
  updated_at: '2026-04-19T15:00:00Z',
  stale: false,
  source: 'mock',
  incidents: [
    {
      id: 'UKMTO-2026-0142',
      date: '2026-04-18T08:30:00Z',
      zone: 'Red Sea & Gulf of Aden',
      zone_id: 'red-sea-gulf-aden',
      position: { lat: 14.5, lng: 42.8 },
      type: 'drone_attack',
      vessel_type: 'Tanker',
      headline: 'Drone attack on tanker 60nm SW of Mocha',
      advisory_text: 'UKMTO WARNING 142/2026. At 0830 UTC on 18 April 2026, a merchant vessel reported being attacked by an armed drone approximately 60 nautical miles southwest of Mocha, Yemen (14°30\'N 042°48\'E). The vessel sustained minor damage and all crew are safe. Vessels in the area are advised to maintain heightened vigilance and report any suspicious activity to UKMTO on +44 (0) 2392 222060 or MHQ@ukmto.org.',
      source_url: 'https://www.ukmto.org/indian-ocean/ukmto-warnings',
    },
    {
      id: 'UKMTO-2026-0141',
      date: '2026-04-17T14:15:00Z',
      zone: 'Red Sea & Gulf of Aden',
      zone_id: 'red-sea-gulf-aden',
      position: { lat: 15.2, lng: 43.5 },
      type: 'missile_attack',
      vessel_type: 'Bulk Carrier',
      headline: 'Missile near-miss on bulk carrier north of Bab-el-Mandeb',
      advisory_text: 'UKMTO WARNING 141/2026. At 1415 UTC on 17 April 2026, a bulk carrier reported a near miss from an anti-ship missile approximately 25 nautical miles north of Bab-el-Mandeb strait (15°12\'N 043°30\'E). No casualties or significant damage reported. The vessel proceeded on its voyage. Masters are strongly advised to transit Bab-el-Mandeb at maximum speed and report all incidents to UKMTO.',
      source_url: 'https://www.ukmto.org/indian-ocean/ukmto-warnings',
    },
    {
      id: 'UKMTO-2026-0140',
      date: '2026-04-16T22:45:00Z',
      zone: 'Red Sea & Gulf of Aden',
      zone_id: 'red-sea-gulf-aden',
      position: { lat: 13.8, lng: 42.2 },
      type: 'drone_attack',
      vessel_type: 'Container Ship',
      headline: 'One-way drone targets container ship west of Hodeidah',
      advisory_text: 'UKMTO WARNING 140/2026. At 2245 UTC on 16 April 2026, a container ship reported being targeted by a one-way attack drone approximately 80 nautical miles west of Hodeidah port, Yemen (13°48\'N 042°12\'E). The drone impacted the vessel\'s accommodation area causing a fire which was subsequently controlled by the crew. No crew injuries reported. The vessel proceeded under own power.',
      source_url: 'https://www.ukmto.org/indian-ocean/ukmto-warnings',
    },
    {
      id: 'UKMTO-2026-0139',
      date: '2026-04-15T06:20:00Z',
      zone: 'Red Sea & Gulf of Aden',
      zone_id: 'red-sea-gulf-aden',
      position: { lat: 11.8, lng: 44.2 },
      type: 'suspicious_approach',
      vessel_type: 'Chemical Tanker',
      headline: 'Suspicious dhow approach east of Aden',
      advisory_text: 'UKMTO WARNING 139/2026. At 0620 UTC on 15 April 2026, a chemical tanker reported being approached by a suspicious fast moving dhow approximately 30 nautical miles east of Aden (11°48\'N 044°12\'E). The vessel increased speed and altered course. The dhow did not pursue. All crew are safe.',
      source_url: 'https://www.ukmto.org/indian-ocean/ukmto-warnings',
    },
    {
      id: 'UKMTO-2026-0138',
      date: '2026-04-14T11:00:00Z',
      zone: 'Red Sea & Gulf of Aden',
      zone_id: 'red-sea-gulf-aden',
      position: { lat: 17.5, lng: 38.8 },
      type: 'missile_attack',
      vessel_type: 'LPG Tanker',
      headline: 'Anti-ship missile passes over vessel in central Red Sea',
      advisory_text: 'UKMTO WARNING 138/2026. At 1100 UTC on 14 April 2026, an LPG tanker reported observing an anti-ship missile passing approximately 500 metres ahead of their vessel in the central Red Sea (17°30\'N 038°48\'E). The missile did not strike the vessel. No casualties. All vessels in the Red Sea are reminded to maintain strict anti-drone/anti-missile watches.',
      source_url: 'https://www.ukmto.org/indian-ocean/ukmto-warnings',
    },
    {
      id: 'UKMTO-2026-0137',
      date: '2026-04-13T19:30:00Z',
      zone: 'Red Sea & Gulf of Aden',
      zone_id: 'red-sea-gulf-aden',
      position: { lat: 14.1, lng: 42.5 },
      type: 'drone_attack',
      vessel_type: 'VLCC',
      headline: 'VLCC sustains drone damage south of Mocha',
      advisory_text: 'UKMTO WARNING 137/2026. At 1930 UTC on 13 April 2026, a VLCC reported being struck by a drone approximately 45 nautical miles south-southwest of Mocha, Yemen (14°06\'N 042°30\'E). Damage sustained to the main deck. A small fire broke out but was extinguished by the vessel\'s fire suppression systems. All crew are safe. The vessel is proceeding under own power to the nearest port for inspection.',
      source_url: 'https://www.ukmto.org/indian-ocean/ukmto-warnings',
    },
    {
      id: 'UKMTO-2026-0136',
      date: '2026-04-12T08:45:00Z',
      zone: 'Somali Coast HRA',
      zone_id: 'somali-coast-hra',
      position: { lat: 4.2, lng: 48.5 },
      type: 'piracy_approach',
      vessel_type: 'Bulk Carrier',
      headline: 'Skiff approach on bulk carrier east of Somalia',
      advisory_text: 'UKMTO WARNING 136/2026. At 0845 UTC on 12 April 2026, a bulk carrier reported being approached by a skiff with approximately 6 persons on board, some armed, approximately 340 nautical miles east of Somalia (04°12\'N 048°30\'E). The vessel implemented hardening measures, increased speed and sent out distress signals. A coalition warship responded. The skiff aborted the approach. All crew are safe.',
      source_url: 'https://www.ukmto.org/indian-ocean/ukmto-warnings',
    },
    {
      id: 'UKMTO-2026-0135',
      date: '2026-04-11T15:20:00Z',
      zone: 'Persian Gulf',
      zone_id: 'persian-gulf',
      position: { lat: 26.5, lng: 55.2 },
      type: 'vessel_harassment',
      vessel_type: 'Product Tanker',
      headline: 'IRGCN vessels intercept product tanker in Persian Gulf',
      advisory_text: 'UKMTO WARNING 135/2026. At 1520 UTC on 11 April 2026, a product tanker reported being intercepted by three IRGCN vessels in the central Persian Gulf (26°30\'N 055°12\'E). The IRGCN vessels directed the tanker to stop but the vessel continued on its course and the IRGCN vessels did not pursue further. Masters transiting the Persian Gulf are advised to maintain strict radio watch on Ch 16.',
      source_url: 'https://www.ukmto.org/indian-ocean/ukmto-warnings',
    },
    {
      id: 'UKMTO-2026-0134',
      date: '2026-04-10T10:00:00Z',
      zone: 'Gulf of Oman',
      zone_id: 'gulf-of-oman',
      position: { lat: 23.5, lng: 58.2 },
      type: 'suspicious_approach',
      vessel_type: 'Chemical Tanker',
      headline: 'Suspicious unlit vessel approach in Gulf of Oman',
      advisory_text: 'UKMTO WARNING 134/2026. At 1000 UTC on 10 April 2026, a chemical tanker reported a suspicious approach by an unlit vessel in the Gulf of Oman (23°30\'N 058°12\'E). The approaching vessel made several close passes before departing. No weapons observed. No casualties.',
      source_url: 'https://www.ukmto.org/indian-ocean/ukmto-warnings',
    },
    {
      id: 'UKMTO-2026-0133',
      date: '2026-04-09T04:30:00Z',
      zone: 'Red Sea & Gulf of Aden',
      zone_id: 'red-sea-gulf-aden',
      position: { lat: 16.8, lng: 41.5 },
      type: 'drone_attack',
      vessel_type: 'Ro-Ro Vessel',
      headline: 'Drone attack on Ro-Ro vessel north of Salif port',
      advisory_text: 'UKMTO WARNING 133/2026. At 0430 UTC on 09 April 2026, a Ro-Ro vessel reported a drone attack approximately 20 nautical miles north of Salif port, Yemen (16°48\'N 041°30\'E). The drone caused superficial damage to the ship\'s superstructure. No crew injuries. The vessel diverted to Jeddah for inspection and temporary repairs.',
      source_url: 'https://www.ukmto.org/indian-ocean/ukmto-warnings',
    },
    {
      id: 'UKMTO-2026-0132',
      date: '2026-04-08T13:15:00Z',
      zone: 'Gulf of Guinea',
      zone_id: 'west-africa-gog',
      position: { lat: 3.8, lng: 6.5 },
      type: 'armed_robbery',
      vessel_type: 'Supply Vessel',
      headline: 'Armed robbery on supply vessel off Nigerian coast',
      advisory_text: 'UKMTO WARNING 132/2026. At 1315 UTC on 08 April 2026, a supply vessel reported an armed robbery approximately 35 nautical miles southwest of Lagos, Nigeria (03°48\'N 006°30\'E). Armed men boarded the vessel, robbed the crew of valuables, and departed. No crew injuries. The vessel reported the incident to local maritime authorities and UKMTO.',
      source_url: 'https://www.ukmto.org/indian-ocean/ukmto-warnings',
    },
    {
      id: 'UKMTO-2026-0131',
      date: '2026-04-07T09:00:00Z',
      zone: 'Red Sea & Gulf of Aden',
      zone_id: 'red-sea-gulf-aden',
      position: { lat: 12.8, lng: 44.5 },
      type: 'drone_attack',
      vessel_type: 'Tanker',
      headline: 'Two drones neutralised near Gulf of Aden entry',
      advisory_text: 'UKMTO WARNING 131/2026. At 0900 UTC on 07 April 2026, a tanker reported two drones approaching the vessel as it entered the Gulf of Aden approximately 15 nautical miles north of Djibouti (12°48\'N 044°30\'E). Both drones were engaged by naval escort assets and neutralised before reaching the vessel. No damage or casualties.',
      source_url: 'https://www.ukmto.org/indian-ocean/ukmto-warnings',
    },
  ],
};
